module.exports = __webpack_public_path__ + "static/media/caller.b4c0c6b5.jpg";